module.exports = __webpack_public_path__ + "static/media/arrow_up_sp.d34cf450.svg";